import { Minus, Plus } from '@components/icons'
import { Button } from '@corratech/pylot-ui'
import cn from 'classnames'
import React, { Dispatch, ReactElement, SetStateAction } from 'react'
import s from './QuantitySelector.module.scss'

// TODO: make `CartQuantity` component based on this one
// remove / add required props
type QuantitySelectorProps = {
    quantity: number
    setQuantity: Dispatch<SetStateAction<number>>
    isEditingDisabled?: boolean
    /** Minimum value (default 1). Use 0 for set/card selectors. */
    min?: number
    /** 'compact' = 32px height, 120px width, smaller buttons and input (e.g. for cards/sets). */
    size?: 'default' | 'compact'
}

const DEFAULT_MIN = 1
const MAX = 99

const getBoundedValue = (value = 0, min: number = DEFAULT_MIN): number => {
    if (value > MAX) return MAX
    if (value < min) return min
    return value
}

export const QuantitySelector = ({
    quantity,
    setQuantity,
    isEditingDisabled = false,
    min = DEFAULT_MIN,
    size = 'default'
}: QuantitySelectorProps): ReactElement => (
    <div
        className={cn(
            s['pdp-quantity'],
            'pdp-qty',
            size === 'compact' && s['pdp-quantity--compact']
        )}
    >
        <Button
            variant="link"
            className={cn({
                'opacity-25 cursor-auto': isEditingDisabled
            })}
            onClick={() =>
                setQuantity((oldQty) => getBoundedValue(oldQty - 1, min))
            }
            disabled={isEditingDisabled}
        >
            <Minus />
        </Button>
        <input
            className={s['quantity']}
            type="number"
            value={quantity}
            name="quantity-input"
            onChange={(e) => {
                if (e.target.value) {
                    setQuantity(Number(e.target.value))
                }
            }}
            onKeyDown={(e) => {
                // @ts-ignore
                const currentNumber = Number(e.target.value)
                if (
                    (currentNumber == 0 && e.key == '0') ||
                    e.key == '-' ||
                    e.key == '.' ||
                    e.key == '+'
                ) {
                    e.preventDefault()
                }
            }}
        />
        <Button
            variant="link"
            className={cn({ 'opacity-25 cursor-auto': isEditingDisabled })}
            disabled={isEditingDisabled}
            onClick={() =>
                setQuantity((oldQty) => getBoundedValue(oldQty + 1, min))
            }
        >
            <Plus />
        </Button>
    </div>
)
